import { useStatsQuery } from '../hooks/useGuests';

export function MonitoringDashboardPage() {
  const { data: stats, isLoading, isError } = useStatsQuery();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <p className="text-ct-text-muted text-lg">Загрузка...</p>
      </div>
    );
  }

  if (isError && !stats) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <p className="text-red-500 text-lg">Ошибка загрузки данных. Проверьте соединение.</p>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto px-2 py-4">
      <h1 className="text-xl font-extrabold tracking-tight text-ct-text mb-6 text-center">
        Мониторинг Конференции
      </h1>

      <div className="space-y-4">
        <MetricCard
          label="Всего участников"
          value={stats?.total ?? 0}
          gradient="from-ct-primary to-ct-secondary"
        />
        <MetricCard
          label="Оплатили участие"
          value={stats?.paid ?? 0}
          gradient="from-emerald-500 to-emerald-600"
        />
        <MetricCard
          label="Зарегистрировано"
          value={stats?.registered ?? 0}
          gradient="from-violet-500 to-violet-600"
        />
        <MetricCard
          label="Посетили ужин"
          value={stats?.dinner ?? 0}
          gradient="from-amber-500 to-amber-600"
        />
      </div>

      <div className="mt-8 text-center text-xs text-ct-text-muted">
        {isError ? (
          <span className="text-red-500">Не удалось обновить данные. Проверьте соединение.</span>
        ) : (
          'Данные обновляются каждые 5 секунд'
        )}
      </div>
    </div>
  );
}

function MetricCard({
  label,
  value,
  gradient,
}: {
  label: string;
  value: number;
  gradient: string;
}) {
  return (
    <div className="rounded-xl bg-ct-surface border border-ct-border overflow-hidden shadow-ct-sm transition-all duration-200 hover:-translate-y-1 hover:shadow-ct-md">
      <div className={`h-1.5 w-full bg-gradient-to-r ${gradient}`} />
      <div className="p-5">
        <div className="text-sm font-semibold text-ct-text-muted mb-1">{label}</div>
        <div className="text-4xl font-extrabold text-ct-text tracking-tight">{value}</div>
      </div>
    </div>
  );
}
